export default {"src":"https://assets.eu.daedalus.fih.io/_next/static/media/sa.99d7f17f.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};